/**
 * Что именно продаём — точная номенклатура выбранного производства.
 *
 * В верхней строке «Товаров» менеджер набирает то, что просит клиент. У каждого
 * производства своя номенклатура: у одного 300х250х600, у другого 300х250х625.
 * В КП должно стоять то, что реально поедет, поэтому имя берётся из позиций уже
 * выбранного предложения (offer.materials собирается из выбранного сравнения),
 * а не из исходной строки заказа.
 *
 * Ничего не считает и не выбирает: производство приходит готовым
 * (selectedOffer.production), номенклатура — готовыми именами позиций. При смене
 * выбранного производства меняется offer, значит меняется и эта сводка.
 *
 * Добавленные допродажи (клей, U-блок) сюда не попадают: они не заказ, а
 * дополнение уже оплаченного места, и живут в карточке машины
 * (см. [[gazProposalUpsells]]).
 */

/** Позиция основного заказа, а не добавленная допродажа. */
export const isOrderedMaterial = (material) => Boolean(material) && !material.isFromInsulationFriends;

/**
 * @param {object}  params
 * @param {object}  params.offer                — выбранное предложение
 * @param {string}  [params.production]         — производство (selectedOffer.production)
 * @param {boolean} params.isMskGazobetonScope  — признак области, приходит готовым
 * @returns {{ production: string|null, items: string[] }|null}
 *   null — вне области либо показывать нечего.
 */
export const buildGazProposalHeadline = ({ offer, production, isMskGazobetonScope } = {}) => {
  if (!isMskGazobetonScope) {
    return null;
  }

  const materials = Array.isArray(offer?.materials) ? offer.materials : [];
  const items = [];
  const seen = new Set();

  for (const material of materials) {
    if (!isOrderedMaterial(material)) {
      continue;
    }
    const name = String(material?.name || '').trim();
    // Пустое имя — это не позиция: рисовать пустую строку нельзя.
    if (!name || seen.has(name)) {
      continue;
    }
    seen.add(name);
    items.push(name);
  }

  const productionName = String(production ?? offer?.production ?? '').trim();

  if (!productionName && items.length === 0) {
    return null;
  }

  return { production: productionName || null, items };
};

export default buildGazProposalHeadline;
